import imageCompression from 'browser-image-compression';

// Función para validar y convertir un archivo a Base64
export const validateAndConvertFile = async (
  file: File,
  maxSizeInMB: number = 2
): Promise<{ isValid: boolean; base64?: string; error?: string }> => {
  // Verificar el tipo de archivo
  if (file.type !== 'application/pdf' && !file.type.startsWith('image/')) {
    return {
      isValid: false,
      error: 'Por favor, selecciona un archivo PDF o una imagen.',
    };
  }

  // Verificar el tamaño del archivo
  if (file.type === 'application/pdf') {
    const fileSizeInMB = file.size / (1024 * 1024); // Convertir a MB
    if (fileSizeInMB > maxSizeInMB) {
      return {
        isValid: false,
        error: `¡Vaya! El fichero que intentas adjuntar es demasiado grande. Por favor, prueba con otro inferior a ${maxSizeInMB}MB.`,
      };
    }
  }

  // Manejar la compresión de imágenes si es necesario
  try {
    let base64: string | null = null;

    if (file.type.startsWith('image/')) {
      // Si es una imagen, intenta comprimirla
      const compressedFile = await handleImageUpload(file);
      if (compressedFile) {
        base64 = compressedFile;
      } else {
        return {
          isValid: false,
          error: 'Error al comprimir la imagen.',
        };
      }
    } else {
      // Si no es una imagen, conviértelo directamente a Base64
      base64 = await convertFileToBase64(file);
    }

    return { isValid: true, base64 };
  } catch (error) {
    console.error('Error al procesar el archivo:', error);
    return {
      isValid: false,
      error: 'Error al procesar el archivo.',
    };
  }
};

// Función auxiliar para convertir un archivo a Base64
export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};

// Función para manejar la compresión de imágenes
export const handleImageUpload = async (
  imageFile: File,
  options = { maxSizeMB: 2, maxWidthOrHeight: 640, useWebWorker: true }
): Promise<string | null> => {
  try {
    if (!imageFile.type.startsWith('image/')) {
      console.error('El archivo no es una imagen.');
      return null;
    }
    // Comprimir la imagen
    const compressedFile = await imageCompression(imageFile, options);
    // Convertir la imagen comprimida a Base64
    const base64File = await imageCompression.getDataUrlFromFile(compressedFile);
    return base64File;
  } catch (error) {
    console.error('Error al comprimir la imagen:', error);
    return null;
  }
};